import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { RouterLink } from '@angular/router';
import { NavigationService } from '../../../../services/navigation.service';

@Component({
  selector: 'app-registration-completed-page',
  imports: [TranslocoDirective, RouterLink],
  templateUrl: './registration-completed-page.component.html',
  styleUrl: './registration-completed-page.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class RegistrationCompletedPageComponent implements OnInit {
  private readonly navigationService = inject(NavigationService);

  ngOnInit(): void {
    this.navigationService.redirectIfLoggedIn();
  }
}
